<template>
  <div id="zt20l">
    <div id="z1">
      <div>ZT20L  分体式扫码终端</div>
      <label>内置安全芯片，信息交互更安全</label>
      <img :src="require('@/assets/pic/zt20l/bg1icon.png')" />
    </div>
    <div id="z2">
      <label>采用键盘与主机分离设计，拥有强劲的解码性能和出众的4G通讯能力，适用于食堂、餐厅、高低柜台等有隔离窗口的收银场景。精心设计的扫码窗口和设备高度，方便消费者进行扫码支付。</label>
    </div>
    <div id="z3">
      <div>外置数字键盘</div>
      <label>采用外置式键盘，可灵活快捷输入</label>
    </div>
    <div id="z4">
      <div>硬解码，识别快，精度高</div>
      <label>采用硬件解码设计，具有识读精度高，速度快的特点</label>
    </div>
    <pdspecs :data="spdata"></pdspecs>
  </div>
</template>

<script>
import pdspecs from '@/components/pdspecs'
export default {
  name: '',
  components: {
    pdspecs
  },
  props: {
    data: Object
  },
  watch: {
    
  },
  data () {
    var _this = this
    return {
      spdata: {
        file: 'ZT20L',
        data: [
          {label: _this.$t('lang.cpu'), desc: ['32位高性能处理器','32位安全处理器'],pic: 'cpu.png'},
          {label: _this.$t('lang.memory'), desc: ['16MB RAM+8MB ROM'],pic: 'ram.png'},
          {label: _this.$t('lang.display'), desc: ['2.4英寸320×240LCD'], pic: 'disp.png'},
          {label: '通讯', desc: ['WIFI / 4G / 4G+WIFI'], pic: 'comm.png'},
          {label: _this.$t('lang.speaker'), desc: ['4Ω-3W 频响范围：100Hz-20KHz≥90dB@50cm'], pic: 'speaker.png'},
          {label: '金额键盘', desc: ['带回显功能的金额数字键盘'], pic: 'mkeyb.png'},
          {label: _this.$t('lang.port'), desc: ['Micro USB ×1'], pic: 'port.png'},
          {label: _THIS.$T('lang.scaner'), desc: [_this.$t('lang.spkofcode')], pic: 'scan.png'},
          {label: _this.$t('lang.protlv'), desc: ['IP52防尘防水'], pic: 'guard.png'},
          {label: _this.$t('lang.bettery'), desc: ['锂电池3.7V/2600mAh'], pic: 'battery.png'},
          {label: _this.$t('lang.size'), desc: ['140mm×102.5mm×95mm'], pic: 'size.png'},
          {label: _this.$t('lang.adapter'), desc: ['输入: AC 100~240V','输出: DC 5V/1A'], pic: 'char.png'},
          {label: _this.$t('lang.suitenv'), desc: [_this.$t('lang.wktemp050')], pic: 'env.png'},
        ]
      }
    }
  },
  methods: {
  
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#zt20l {
  background: white;
  margin-top: -.93rem;
}
#z1 {
  height: 9rem;
  background-image: url('../../assets/pic/zt20l/bg1.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.5rem;
  color: #4D4D4D;
}
#z1 div {
  margin-top: 3.94rem;
  font-size: .6rem;
  font-weight: bold;
}
#z1 label {
  display: block;
  font-weight: 400;
  margin-top: .12rem;
  margin-bottom: .26rem;
  font-size: .4rem;
}
#z1 img {
  width: 3.03rem;
}
#z2 {
  height: 1.78rem;
  background: #A6A6A6;
  text-align: center;
}
#z2 label {
  display: inline-block;
  width: 12.7rem;
  font-size: .24rem;
  font-weight: 400;
  color: #FFFFFF;
  margin-top: .45rem;
  line-height: .48rem;
}

#z3 {
  height: 9rem;
  background-image: url('../../assets/pic/zt20l/bg2.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.42rem;
  color: #4D4D4D ;
}
#z3 div {
  margin: 3.12rem 0 .15rem 0;
  font-size: .65rem;
  font-weight: bold;
}
#z3 label {
  margin-left: .05rem;
  width: 5.4rem;
  display: block;
  font-size: .24rem;
  font-weight: 400;
}

#z4 {
  height: 9rem;
  background-image: url('../../assets/pic/zt20l/bg3.png');
  background-size: 100% 100%;
  overflow: hidden;
  text-align: center;
  color: #4D4D4D;
}
#z4 div {
  margin: 1.3rem 0 .27rem 0;
  font-size: .6rem;
  font-weight: bold;
}
#z4 label {
  display: block;
  font-size: .24rem;
  font-weight: 400;
}
</style>
